import React from 'react';
import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    Grid,
    Button,
    TextField,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(1),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(2),
    },
    input: {
        display: 'none',
    },
}));

export default function FormPerfil(props) {
    const classes = useStyles();
    const professionalProfile = props.professionalProfile.professionalProfile
    const notFound = props.professionalProfile.professionalProfileNotFound

    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [skills, setSkills] = useState("");

    React.useEffect(() => {
        if (!notFound) {
            setTitle(professionalProfile.title)
            setDescription(professionalProfile.description)
            setSkills(professionalProfile.skills)
        }

    }, [professionalProfile])

    onsubmit = (event) => {
        event.preventDefault();
        props.onSubmit(title, description, skills);
    }

    return (
        <>
            <div className={classes.paper}>
                <form className={classes.form} autoComplete="off">
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                required
                                id="outlined-required"
                                label="Título"
                                placeholder='Ex.: Desenvolvedor Web'
                                variant="outlined"
                                fullWidth
                                value={title || ""}
                                onChange={(e) => setTitle(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                id="outlined-multiline-static"
                                required
                                label="Descrição profissional"
                                multiline
                                rows={4}
                                fullWidth
                                placeholder="Descrição profissional"
                                variant="outlined"
                                value={description || ""}
                                onChange={(e) => setDescription(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                id="outlined-multiline-static"
                                required
                                label="Competências (separadas por ponto e vírgula)"
                                multiline
                                rows={4}
                                fullWidth
                                placeholder="Ex.: Redação; Pacote Office; Inglês"
                                variant="outlined"
                                value={skills || ""}
                                onChange={(e) => setSkills(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                fullWidth
                            >
                                {notFound ? "SALVAR" : "ATUALIZAR"}
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </div>
        </>
    );
}